var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './Menubar.css';
import React from 'react';
import { observer } from 'mobx-react';
let NavBar = class NavBar extends React.PureComponent {
    render() {
        const { app, leftContent, rightContent, centerContent } = this.props;
        return (React.createElement("div", { style: { height: 45, width: '100%' }, key: "navbar" },
            React.createElement("div", { onMouseEnter: app.menubar.setHoveringTimer, onMouseLeave: app.menubar.removeHoveringTimer, style: {
                    zIndex: 3,
                    background: 'linear-gradient(to bottom, #3c3c3c 0%, #222 100%)',
                    position: 'fixed',
                    width: '100%',
                    display: 'flex',
                    height: 45,
                    color: '#9d9d9d',
                    alignItems: 'stretch',
                    flexWrap: 'nowrap',
                    fontSize: 15,
                } },
                React.createElement("div", { style: {
                        flex: '0 1 auto',
                        display: 'flex',
                        flexWrap: 'nowrap',
                    } }, leftContent),
                React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center' } }, centerContent),
                React.createElement("div", { style: {
                        flex: '0 1 auto',
                        display: 'flex',
                        flexWrap: 'nowrap',
                    } }, rightContent))));
    }
};
NavBar = __decorate([
    observer
], NavBar);
export { NavBar };
